import Head from 'next/head'
import { DOMAIN, FB_APP_ID } from '../../lib/Utils'

const title = 'Local, Regional & OTR Trucking News | Driversjobchoice.com'
const description =
  'Trucking News About High Paying, Local, Regional & OTR Truck Driver Jobs. Your Job, Your Choice! Drivers Job Choice.'
const NewsListHead = () => {
  return (
    <Head>
      <title>{title}</title>

      <meta name="twitter:card" content="summary" key="twitterCard"></meta>
      <meta
        property="og:url"
        content={`${DOMAIN}/truck-drivers-news`}
        key="ogUrl"></meta>
      <meta property="og:title" content={title} key="ogTitle" />

      <meta name="description" content={description} key="description"></meta>
      <meta
        property="og:description"
        content={description}
        key="ogDescription"></meta>
      <meta
        property="og:image"
        content={`${DOMAIN}/assets/img/company/default.webp`}
        key="ogImage"></meta>

      <meta property="og:type" content="website" key="ogType"></meta>
      <meta property="fb:app_id" content={FB_APP_ID} key="fbAppId"></meta>
      <meta
        property="keywords"
        content="truck driver jobs, truck driving jobs, driver jobs, driving jobs, cdl jobs, owner operator jobs, trucking, trucking jobs, local driver jobs, OTR driver jobs, trucks, carriers, trucking companies, truck carriers"
        key="keywords"></meta>
    </Head>
  )
}

export default NewsListHead
